import { render, staticRenderFns } from "./transactionDetail.vue?vue&type=template&id=2815b1dd&scoped=true&"
import script from "./transactionDetail.js?vue&type=script&lang=js&"
export * from "./transactionDetail.js?vue&type=script&lang=js&"
import style0 from "./transactionDetail.scss?vue&type=style&index=0&id=2815b1dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2815b1dd",
  null
  
)

export default component.exports